import { getListBrowserStore } from '@ts-private/list-browser';
import { dataTypes } from '../constants';

export const metadataStore = getListBrowserStore({
  filterDefinitions: [
    {
      name: 'code',
      caption: 'Metadata.Code',
      type: 'text'
    },
    {
      name: 'name',
      caption: 'Metadata.Name',
      type: 'text'
    },
    {
      name: 'dataType',
      caption: 'Metadata.DataType',
      type: 'select',
      underlyingType: 'text',
      options: dataTypes.map(({ id, name }) => ({ value: id, label: name }))
    },
    {
      name: 'entityType',
      caption: 'Metadata.Entity',
      type: 'text'
    }
  ],
  orderByFields: [
    {
      caption: 'Metadata.Code',
      value: 'code'
    },
    {
      caption: 'Metadata.Name',
      value: 'name'
    }
  ],
  pager: {
    orderBy: 'name',
    direction: 'asc'
  }
});
